import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Switch,
  ModalContent,
  Button,
} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";

const AcceptModal = ({
  isOpen,
  onClose,
  onConfirm,
  quoteId,
  accessToken,
  Id,
  isWarranty,
  dispatchDate,
  onToggleWarranty,
  initialHasWarranty,
}) => {
  const [has_warranty, setHasWarranty] = useState(initialHasWarranty);
  const [totalPrice, setTotalPrice] = useState(null);
  const [warrantyPrice, setWarrantyPrice] = useState(null);
  const [optionTotalPrice, setOptionTotalPrice] = useState(null);
  const [optionWarrantyPrice, setOptionWarrantyPrice] = useState(null);

  useEffect(() => {
    setHasWarranty(initialHasWarranty);
  }, [initialHasWarranty]);

  const handleToggleWarranty = async (checked) => {
    setHasWarranty(checked);
    try {
      const payload = {
        warrantyStatus: checked,
        [quoteId === Id ? "main_id" : "option_id"]: Id,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/quotes/approve/${quoteId}/${checked}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data && response.data.details) {
        const { quote, selected_option } = response.data.details;

        if (quote && Id === quote.id) {
          setTotalPrice(quote.total_price);
          setWarrantyPrice(quote.warranty_price);
        }

        if (selected_option && Id === selected_option.id) {
          setOptionTotalPrice(selected_option.total);
          setOptionWarrantyPrice(selected_option.warranty_price);
        }
      }

      toast.success(
        `Warranty ${checked ? "enabled" : "disabled"} successfully`
      );
      onToggleWarranty(Id, checked);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to update warranty"
      );
    }
  };

  const handleClose = () => {
    onClose();
    window.location.reload();
  };

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={handleClose}
      className="p-3"
      placement="center"
    >
      <ModalContent>
        <ModalBody className="flex flex-col items-center space-y-2">
          <h1 className="font-semibold text-lg">Proceeded Quote</h1>
          <hr className="w-full border-gray-300" />
          <p className="font-semibold">Dispatch date:{dispatchDate}</p>
          {/* 
          <div className="flex items-center justify-between w-full px-4 ">

            <p className="text-center">Are You Sure You Want To Add Warranty?</p>
            <div className="flex flex-col items-center">
              <Switch
                isSelected={has_warranty}
                onValueChange={handleToggleWarranty}
              />
            </div>
          </div> */}
          <div className="flex items-center justify-between w-full px-4">
            <p className="text-left capitalize flex-1 font-semibold">
              Would you like to accept the extended warranty?
              <br />
              <span className="text-[12px] text-gray-900 font-semibold">
                (If offered, extra charges may apply)
              </span>
            </p>

            <div className="flex items-center">
              <Switch
                isSelected={has_warranty}
                onValueChange={handleToggleWarranty}
              />
            </div>
          </div>
          <div className="">
            {" "}
            {has_warranty && (
              <span className="text-green-600 text-sm mt-1">
                Warranty Price Added
              </span>
            )}
          </div>

          {totalPrice !== null && (
            <div className="text-center font-semibold mt-3">
              {warrantyPrice !== null && (
                <p>
                  Warranty Price:{" "}
                  <span className="text-red-600">${warrantyPrice}</span>
                </p>
              )}
              <p>
                Total Price:{" "}
                <span className="text-blue-600">${totalPrice}</span>
              </p>
            </div>
          )}

          {optionTotalPrice !== null && (
            <div className="text-center font-semibold mt-3">
              <p>
                Total:{" "}
                <span className="text-purple-600">${optionTotalPrice}</span>
              </p>
              {optionWarrantyPrice !== null && (
                <p>
                  {" "}
                  Warranty Price:{" "}
                  <span className="text-red-600">${optionWarrantyPrice}</span>
                </p>
              )}
            </div>
          )}
        </ModalBody>

        <ModalFooter className="flex justify-center gap-4">
          <Button color="danger" variant="light" onPress={handleClose}>
            No
          </Button>
          <Button color="primary" onPress={onConfirm} disabled={isWarranty}>
            Accept Quote
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AcceptModal;
